import { useEffect, useState } from "react";
import DropdownButton from "../common/DropdownButton";
import { Button, Flex, Input } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch, faXmark } from "@fortawesome/free-solid-svg-icons";
import styles from "./order.module.scss";

const OrderMenu: React.FC<any> = ({
  sizes,
  deliveryMethods,
  deliveryStatus,
  templates,
  setFilters,
  filters,
  dates,
  resetDates,
}) => {
  const [template, setTemplate] = useState<any>(filters?.template || null);
  const [size, setSize] = useState<any>(null);
  const [deliveryMethod, setDeliveryMethod] = useState<any>(null);
  const [status, setStatus] = useState<any>(filters?.status || null);
  const [search, setSearch] = useState<any>(null);

  const handleSearch = () => {
    setFilters({
      ...filters,
      search,
    });
  };

  const handleClearSearch = () => {
    setSearch(null);
    setFilters({
      ...filters,
      search: null,
    });
  };

  const clearAll = () => {
    resetDates();
    setTemplate(null);
    setDeliveryMethod(null);
    setStatus(null);
    setSize(null);
    setSearch(null);
    setFilters((old: any) => ({ ...old, search: null }));
  };

  const hasFilters = () =>
    Boolean(
      (dates && dates[1] !== "mtd") ||
        template ||
        size ||
        deliveryMethod ||
        status ||
        search
    );

  const clearColor = () => (hasFilters() ? "#F33A3A" : "#CCCFD3");

  useEffect(() => {
    setFilters({
      ...filters,
      template,
      size,
      deliveryMethod,
      dates,
      status,
    });
    // eslint-disable-next-line
  }, [dates, size, deliveryMethod, template, status]);

  return (
    <Flex gap={12} style={{ margin: "15px 0px" }}>
      <DropdownButton
        items={templates}
        label="Template"
        selected={template}
        setSelected={setTemplate}
      />
      <DropdownButton
        items={sizes}
        label="Size"
        selected={size}
        setSelected={setSize}
      />
      <DropdownButton
        items={deliveryMethods}
        label="Delivery Method"
        selected={deliveryMethod}
        setSelected={setDeliveryMethod}
      />
      <DropdownButton
      
        items={deliveryStatus}
        label="Delivery Status"
        selected={status}
        setSelected={setStatus}
      />
      { hasFilters() && 
        <Button
          color="default"
          variant="link"
          onClick={clearAll}
          style={{
            color: clearColor(),
            padding: '0px',
            fontFamily: "'Lato', sans-serif",
            fontWeight: 700,
          }}
        >
          Clear All
        </Button>
      }
      <Input
        placeholder="Search ID Numbers"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        onPressEnter={handleSearch}
        className={styles.searchInput}
        style={{
          width: 250,
          marginLeft: "auto",
          borderRadius: "50px",
          borderColor: "#EBECED",
          lineHeight: "32px",
        }}
        suffix={
          search ? (
            <Flex gap={8} align="center">
              <FontAwesomeIcon
                icon={faXmark}
                onClick={handleClearSearch}
                style={{ cursor: "pointer", color: "rgba(0, 0, 0, 0.25)" }}
              />
              <FontAwesomeIcon
                icon={faSearch}
                onClick={handleSearch}
                style={{ cursor: "pointer", color: "rgba(0, 0, 0, 0.25)" }}
              />
            </Flex>
          ) : (
            <FontAwesomeIcon
              icon={faSearch}
              onClick={handleSearch}
              style={{ cursor: "pointer", color: "rgba(0, 0, 0, 0.25)" }}
            />
          )
        }
      />
    </Flex>
  );
};

export default OrderMenu;
